<div>
  <button type="button" (click)="isCollapsed = !isCollapsed" class="btn btn-xs btn-danger mb-3">{{ isCollapsed ? props.btnTitleClosed : props.btnTitleOpened }}</button>
  <div [collapse]="isCollapsed">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>
